// Get all coin history
export const GET_COIN_HISTORY_START = 'GET_COIN_HISTORY_START';
export const GET_COIN_HISTORY_SUCCESS = 'GET_COIN_HISTORY_SUCCESS';
export const GET_COIN_HISTORY_FAILURE = 'GET_COIN_HISTORY_FAILURE';

// Get user coin history
export const GET_USER_COIN_HISTORY_START = 'GET_USER_COIN_HISTORY_START';
export const GET_USER_COIN_HISTORY_SUCCESS = 'GET_USER_COIN_HISTORY_SUCCESS';
export const GET_USER_COIN_HISTORY_FAILURE = 'GET_USER_COIN_HISTORY_FAILURE';

// Get coin history statistics
export const GET_COIN_HISTORY_STATS_START = 'GET_COIN_HISTORY_STATS_START';
export const GET_COIN_HISTORY_STATS_SUCCESS = 'GET_COIN_HISTORY_STATS_SUCCESS';
export const GET_COIN_HISTORY_STATS_FAILURE = 'GET_COIN_HISTORY_STATS_FAILURE';

// Create coin history
export const CREATE_COIN_HISTORY_START = 'CREATE_COIN_HISTORY_START';
export const CREATE_COIN_HISTORY_SUCCESS = 'CREATE_COIN_HISTORY_SUCCESS';
export const CREATE_COIN_HISTORY_FAILURE = 'CREATE_COIN_HISTORY_FAILURE';

// Clear error
export const CLEAR_COIN_HISTORY_ERROR = 'CLEAR_COIN_HISTORY_ERROR';